<template>
	<div>
		<div class="supplier-extra" v-if="supplierExtraBoxVisible && !isMobile">
			<p v-for="(value, name) in updatedLocationExtra" :key="name">
				{{ name }}: <b>{{ value }}</b>
			</p>
		</div>
	</div>
</template>

<script>
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import 'leaflet-rotatedmarker'
import asyncQueue from 'async/queue'

export default {
	props: {
		mapView: {
			required: true
		},
		order: {
			required: true
		}
	},
	data: function () {
		var result = {
			supplier: {},
			localeData: null,
			locationHistory: [],
			locateInterval: null,
			pointQueue: null,
		}
		return result
	},
	mixins: [],
	computed: {
		isFocusTab () {
			return this.$store.state.isFocusTab
		},
		supplierExtraBoxVisible () {
			return this.$route.query.process_location && this.$route.query.process_location === "true" && this.localeData && this.localeData.extra && true
		},
		updatedLocationExtra () {
			let result = {}
			if (this.supplierExtraBoxVisible) {
				const roundFields = ['battery_percentage', 'horizontal_accuracy', 'altitude']
				for (let key in this.localeData.extra) {
					if (roundFields.indexOf(key) > -1) {
						result[key] = Math.round(this.localeData.extra[key])
					} else if (key == 'time') {
						result[key] = this.$dayjs.unix(this.localeData.extra[key]).format("DD MMM HH:mm:ss")
					} else {
						result[key] = this.localeData.extra[key]
					}
				}
			}
			return result
		}
	},
	methods: {
		async init (locate) {
			const mapIconUrl = (this.order.service && this.order.service.map_icon_url) || `${window.location.origin}/supplier-marker.png`
			let rawIconSize = await new Promise(resolve => {
				var loadImageTimeout = setTimeout(() => {
					resolve({
						width: 32,
						height: 70
					})
				}, 4000);

				var img = new Image()
				img.onload = function() {
					if (loadImageTimeout) clearTimeout(loadImageTimeout)

					resolve({
						width: this.width,
						height: this.height
					})
				}
				img.src = mapIconUrl
			})

			const isSquareSize = rawIconSize && rawIconSize.width === rawIconSize.height
			const iconWidth = isSquareSize
				? 54
				: 32
			const iconHeight = isSquareSize
				? 54
				: rawIconSize.height ? ((rawIconSize.height*iconWidth)/rawIconSize.width) : 64
			// console.log('iconWidth x iconHeight', iconWidth, iconHeight)
			let iconSize = L.point(iconWidth, iconHeight)
			let shadowSize = L.point(iconWidth, iconHeight)
			const supplierMarkerIcon = L.icon({
				iconUrl: mapIconUrl,
				iconRetinaUrl: mapIconUrl,
				iconSize: iconSize,
				shadowUrl: '',
				shadowRetinaUrl: mapIconUrl,
				shadowSize: shadowSize,
				className: 'supplier-marker-icon'
			})
			let supplierMarkerOptions = {
				icon: supplierMarkerIcon,
				opacity: 1
			}
			const latLng = new L.LatLng(locate.lat, locate.lng)
			this.supplier.marker = new L.Marker(latLng, supplierMarkerOptions)
			this.mapView.addLayer(this.supplier.marker)
			this.initMarkerCustomFunctions()
			var r = this.randomDegree()
			this.supplier.marker.setAngle(r)
			this.initPointQueue()
			this.$emit('updateSupplierLocation', latLng)
			setTimeout(() => {
				// this.fitBounds(latLng)
			}, 200)

			this.mapView.on('zoomstart', function () {
				if (this.supplier.marker) {
					this.supplier.marker.onZoomStart()
				}
			}.bind(this))

			this.mapView.on('zoomend', function () {
				if (this.supplier.marker) {
					this.supplier.marker.onZoomEnd()
				}
			}.bind(this))

			this.supplier.marker.on('click', () => {
				const latlng = this.supplier.marker.getLatLng()
				this.mapView.flyTo(latlng, 16)
			})
		},
		fitBounds (supplierLocation, callback) {
			let mapBounds = []

			if (this.order && this.order.path) {
				this.order.path.forEach(function (point) {
					mapBounds.push(L.latLng(point.lat, point.lng))
				})
			}

			const latLng = new L.LatLng(supplierLocation.lat, supplierLocation.lng)
			mapBounds.push(latLng)

			if (mapBounds.length > 0) {
				const bounds = L.latLngBounds(mapBounds)
				const fitBoundsOptions = {
					paddingTopLeft: [30, 20],
					paddingBottomRight: [30, 20]
				}

				this.mapView.flyToBounds(bounds, fitBoundsOptions)
				callback && callback()
			}
		},
		locateSupplier () {
			if (!this.isFocusTab) return

			const api = `${process.env.VUE_APP_API_URL}${this.$constants.API.supplier.locate_supplier}?order_id=${this.order._id}&user_id=${this.order.user_id}`
			window.axios.get(api)
				.then((response) => {
					const data = response.data
					if (data && data.order_status) {
						this.localeData = data

						if (!this.supplier.marker) {
							this.init(data)
						} else {
							this.updateMarker(data)
						}

						if (!this.locateInterval) {
							this.initInterval()
						}
					} else {
						this.localeData = null
						this.stopInterval()
					}
				})
				.catch(() => {
					this.localeData = null
					this.stopInterval()
					this.$emit('invalidOrderMode')
				})
		},
		stopInterval () {
			if (this.locateInterval) {
				clearInterval(this.locateInterval)
			}
		},
		initInterval () {
			const duration = 7000
			this.stopInterval()
			this.locateInterval = setInterval(function () {
				this.locateSupplier()
			}.bind(this), duration)
		},
		updateMarker (location) {
			this.pointQueue.push(location, (err) => {
				if (err) {
					console.log('finished processing foo', err)
				} else if (location) {
					this.$emit('updateSupplierLocation', new L.LatLng(location.lat, location.lng))
				}
			})
		},
		initMarkerCustomFunctions () {
			/* eslint-disable */
			this.supplier.marker.options = {
				distance: 200,
				interval: 100,
				autoStart: true,
				onEnd: function () {},
				clickable: false,
				run: false,
				isFocusToSupplierMarker: true
			}

			this.supplier.marker.initialize = function (latlngs, options) {
				this._latlngs = latlngs;
				this.setLine(latlngs);
				L.Marker.prototype.initialize.call(this, latlngs[0], options)
			}

			this.supplier.marker.setTransition = function (element, transition) {
				if (element) {
					element.style[L.DomUtil.TRANSITION] = transition
				}
			}

			this.supplier.marker.enableTransitions = function (speed) {
				// Only if CSS3 transitions are supported
				var transition = 'all ' + (speed || this.options.interval) + 'ms linear'
				this.setTransition(this._icon, transition)
				this.setTransition(this._shadow, transition)
				this.options.interval = speed
			}

			this.supplier.marker._setPos = function (pos, angle, speed) {
				L.Marker.prototype._setPos.call(this, pos);

				if (this._icon){
					if (L.DomUtil.TRANSFORM) {
						// use the CSS transform rule if available
						this.enableTransitions(speed)

						var trans = this._icon.style[L.DomUtil.TRANSFORM]
						var spIdx = trans.indexOf(" rotate")
						trans = spIdx > -1 ? trans.slice(0, spIdx + 1) : trans

						this._icon.style[L.DomUtil.TRANSFORM] = trans + ' rotate(' + angle + 'deg)'
						if (!this._shadow) this._shadow = {}
						if (!this._shadow.style) this._shadow.style = {}
						this._shadow.style[L.DomUtil.TRANSFORM] = trans + ' rotate(' + angle + 'deg)'
					} else if (L.Browser.ie) {
							// fallback for IE6, IE7, IE8
							var rad = this.options.angle * (Math.PI / 180),
								costheta = Math.cos(rad),
								sintheta = Math.sin(rad)
							this._icon.style.filter += ' progid:DXImageTransform.Microsoft.Matrix(sizingMethod=\'auto expand\', M11=' +
								costheta + ', M12=' + (-sintheta) + ', M21=' + sintheta + ', M22=' + costheta + ')'
					}
				}
			}

			this.supplier.marker._setLatLng = function (pos, angle, speed) {
				if (this._icon){
					this.enableTransitions(speed)
					this.setLatLng(pos).update()

					if (L.DomUtil.TRANSFORM) {
						var trans = this._icon && this._icon.style[L.DomUtil.TRANSFORM]

						this._icon.style[L.DomUtil.TRANSFORM] = trans + ' rotate(' + angle + 'deg)'
						if (!this._shadow) this._shadow = {}
						if (!this._shadow.style) this._shadow.style = {}
						this._shadow.style[L.DomUtil.TRANSFORM] = trans + ' rotate(' + angle + 'deg)'
					} else if (L.Browser.ie) {
							// fallback for IE6, IE7, IE8
							var rad = this.options.angle * (Math.PI / 180),
								costheta = Math.cos(rad),
								sintheta = Math.sin(rad)
							this._icon.style.filter += ' progid:DXImageTransform.Microsoft.Matrix(sizingMethod=\'auto expand\', M11=' +
								costheta + ', M12=' + (-sintheta) + ', M21=' + sintheta + ', M22=' + costheta + ')'
					}
				}
			}

			this.supplier.marker.onZoomStart = function () {
				this.setOpacity(0)
				this.enableTransitions(100)
			}

			this.supplier.marker.onZoomEnd = function () {
				this.enableTransitions(100)
				var rotation = this.options.angle
				this._setLatLng(this._latlng, rotation, 0)
				this.setOpacity(1)
			}

			this.supplier.marker.animate = function () {
					var self = this,
							len = this._latlngs.length,
							speed = this.options.interval;

					self.enableTransitions(100);
					if (this._i === len) {
							if (len === 1) {
									var _latlng = this._latlngs[0];
									this._latlng = _latlng;
							}
					} else if (this._i < len) {
							var _latlng = this._latlngs[this._i];
							this._latlng = _latlng;
							if (this._i > 1 && !_latlng.speed) {
									this._i += 1;
									_latlng = this._latlngs[this._i];
							}

							speed = _latlng && _latlng.speed ? (_latlng.speed * 5500) : 100;

							if (this._latlngs[this._i - 1] && this._latlngs[this._i]){
									var d = this._latlngs[this._i - 1] && parseFloat(this._latlngs[this._i - 1].lat);
									var e = this._latlngs[this._i - 1] && parseFloat(this._latlngs[this._i - 1].lng);
									var b = this._latlngs[this._i] && parseFloat(this._latlngs[this._i].lat);
									var c = this._latlngs[this._i] && parseFloat(this._latlngs[this._i].lng);
									this.options.angle = _self.getDegree(b, c, d, e);
							}

							this._setPos(_latlng, this.options.angle, 800);

							self._j = 0;
							self.setLatLngTimeout = setTimeout(function () {
									if (self._j >= 1) {
											self._j = 0;
											clearTimeout(self.setLatLngTimeout);
									} else {
											self._setLatLng(_latlng, self.options.angle, speed - 800);

											self._j += 1;
									}
							}, 800);

							this._i++;
					}

					this._tid = setTimeout(function () {
							if (self._i > len) {
									self._i = len;
							}

							self.animate();
					}, speed);
			}

			this.supplier.marker.start = function () {
				if (!this._i) {
						this._i = 1
				}
				this.animate()
			}

			this.supplier.marker.stop = function () {
				if (this._tid) {
					clearTimeout(this._tid)
				}
			}

			this.supplier.marker.setLine = function (latlngs) {
				if (L.DomUtil.TRANSITION) {
					// No need to to check up the line if we can animate using CSS3
					this._latlngs = latlngs
				} else {
					// Chunk up the lines into options.distance bits
					//this._latlngs = this._chunk(latlngs);
					this.options.distance = 10
					this.options.interval = 30
				}
			}

			this.supplier.marker.updateLatLngs = function (latlngs) {
					this._latlngs = this._latlngs.concat(latlngs);
			};

			this.supplier.marker.setRotation = function (a) {
					this.enableTransitions(100);
					var b = this._icon;
					if (180 < Math.abs(a - this.direction)) {
							a = a < this.direction ? this.direction + a : 0;
					}
					parseInt(a, 10);
					a = "rotate(" + parseInt(this.direction, 10) + "deg)";
					b.style.transitionProperty = "transform";
					b.style.transitionDuration = 200; //this.interval / 3 + "ms";
					b.style.webkitTransform = a;
					b.style.OTransform = a;
					b.style.MozTransform = a;
					b.style.msTransform = a;
			};

			// =============
			this.supplier.marker.setAngle = function (d) {
				var center = this.supplier.marker.getLatLng();
				this.supplier.marker.options.angle = d;
				this.supplier.marker._setLatLng(center, d, 700);
			}.bind(this)
			/* eslint-enable */
		},
		randomDegree () {
			return Math.random() * 180
		},
		/* eslint-disable */
		getDegree(prev_lat, prev_lng, curr_lat, curr_lng) {
			var result = 0;
			var currentDegree = this.supplier.marker['options'] ? this.supplier.marker['options']['angle'] : 0
			var p2 = {
					x: prev_lat,
					y: prev_lng
			};

			var p1 = {
					x: curr_lat,
					y: curr_lng
			};

			var degree = 0;
			if (p1.x && p1.y && p2.x && p2.y) {
				degree = Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI
				var mDegree = degree < 0 ? degree + 0 : degree - 360
				var tDegree = degree >= 0 ? degree + 0 : degree + 360

				result = (Math.abs(mDegree) + currentDegree) < (tDegree - currentDegree)
					? mDegree
					: tDegree
			}

			if (prev_lat === curr_lat && prev_lng === curr_lng) {
				result = currentDegree
			}

			return result
		},
		initPointQueue(){
			this.pointQueue = asyncQueue(function (location, callback) {
				this.animate(location, () => {
					// self.fitMapCenter()
					callback()
				})
			}.bind(this), 1)
		},
		/* eslint-enable */
		animate (location, callback) {
			this.locationHistory.unshift(location)
			let marker = this.supplier.marker

			var angle = this.getDegree(
				location.lat,
				location.lng,
				location.prev_lat || location.lat,
				location.prev_lng || location.lng
			)

			var angleDuration = 700
			var current = marker.getLatLng()
			var nextPoint = L.latLng(location.lat, location.lng)

			marker._setPos(current, angle, angleDuration)
			marker.options.angle = angle

			const currentExtraTime = location.extra.time
			const prevExtraTime = location.prev_extra ? location.prev_extra.time : location.extra.time
			const now = new Date()
			const dur = (currentExtraTime || now.getTime() / 1000) - prevExtraTime
			// now.getTime() / 1000 - prevExtraTime
			const speedByDuration = dur * 700

			var speed = location && location.extra && location.extra.speed > 0 && dur < 40
				? (location.extra.speed * 7000) - angleDuration
				: speedByDuration
			speed = speed > 12000 ? 12000 : speed

			setTimeout(function () {
				marker._setLatLng(nextPoint, marker.options.angle, speed)
				callback()
			}, angleDuration)
		}
	},
	beforeCreate () {
		// console.log('bg beforeCreate', new Date())
	},
	created () {
	},
	beforeMount () {

	},
	mounted () {
		this.locateSupplier()
	},
	beforeDestroy () {
		if (this.locateInterval) {
			clearInterval(this.locateInterval)
		}

		if (this.pointQueue) {
			this.pointQueue.tasks = []
		}
	},
	destroyed () {

	}
}
</script>

<style lang="scss">
.supplier-marker-icon{
	z-index: 99999 !important;
	transform-origin: 50% 50% !important;
}

.supplier-extra {
	position: fixed;
	bottom: 16px;
	right: 16px;
	z-index: 999;
	background-color: #fff;
	padding: 10px;
	min-width: 150px;
	font-size: 12px;
	text-align: right;
}
</style>
